/**
 * External store for navigation-block state.
 *
 * Lives outside React so that non-React code (e.g. useLogout callback)
 * can synchronously check whether an in-flight mutation is active.
 *
 * `useNavigationBlock` increments/decrements the counter;
 * consumers call `getNavigationBlockSnapshot()` to read it.
 */
type Listener = () => void;

let blockCount = 0;
const listeners = new Set<Listener>();

function emitChange(): void {
  listeners.forEach(listener => listener());
}

export function incrementBlock(): void {
  blockCount += 1;
  emitChange();
}

export function decrementBlock(): void {
  blockCount = Math.max(0, blockCount - 1);
  emitChange();
}

export function getNavigationBlockSnapshot(): boolean {
  return blockCount > 0;
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}

export function resetNavigationBlockStore(): void {
  blockCount = 0;
  emitChange();
}
